const title = "Keep going - it's worth it!";
const subHeader = 'Stick around for a few more steps to:';
const bulletOne =
  'Get personalized recommendations with no impact to your credit';
const bulletTwo =
  'Narrow in on the best credit cards from our partners based on your preferences';
const bulletThree = 'Save time with our proprietary recommendation system';
const primaryCTA = 'Keep Going';
const secondaryCTA = 'No Thanks';

export {
  title,
  subHeader,
  bulletOne,
  bulletTwo,
  bulletThree,
  primaryCTA,
  secondaryCTA,
};
